<!--
 * @Date: 2021-07-26 15:25:07
 * @LastEditors: natsu
 * @LastEditTime: 2021-09-24 09:33:20
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>printSdk</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/printSdk/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.0.7",
          linkList: [ur + "1.0.7/printSdk.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListPrintSdk.vue